import React from 'react';
import styled, {css} from 'styled-components';
import media from "../styles/media";


const List = styled.ul`
  line-height: 1.4em;
  font-weight: 600;
  color: var(--color-${props => props.color || 'cyan'});

  li {
    margin-bottom: 0.6em;

    span {
      flex: 1;
    }

    i {
      margin: 3px 0.3em 0 0;
    }
  }

  ${media.from.tablet(css`
    font-size: 1.2rem;
    ${props => props.columns > 1 && css`
      column-count: ${props.columns};
      column-gap: var(--content-spacing);
    `}
  `)}
`


const HighlightsList = ({className, items, columns = 1, color}) => {
    return (
        <List className={className} color={color} columns={columns}>
            {items && items.map((item, i) =>
                <li key={i}>
                    <i className='ws-logo-nolids'/>
                    <span>{item}</span>
                </li>
            )}
        </List>
    )
};

export default HighlightsList;
